import React, { PureComponent } from 'react';
import { View } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import { isEmpty as _isEmpty, map as _map } from 'lodash';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { withTheme, LightThemeColors } from '../Themes';
import VFText from '../VFText';

import styles from './UsageChart.Styles';
import UsageIndicator from './UsageIndicator';
import { BORDER_TYPES, ORIENTATION_TYPES } from './UsageIndicator/UsageIndicator.Enums';

class UsageChart extends PureComponent {
  constructor(props) {
    super(props);
  }

  renderChartColumns = () => {
    const { style, data, colors } = this.props;
    const { columnWidth, columnBorderRadius } = style;
    return _map(data, item => {
      return (
        <UsageIndicator
          values={item?.values}
          width={columnWidth}
          borderType={BORDER_TYPES.END}
          type={ORIENTATION_TYPES.VERTICAL}
          borderRadius={columnBorderRadius}
          colors={colors}
          testID={FoundationTestKeys.usageChartUsageIndicatorSelf}
        />
      );
    });
  };

  renderChartTimeLabels = () => {
    const { data, theme, style } = this.props;
    const { timeLabelsTextStyle } = style;

    return _map(data, element => {
      const { startDate, endDate } = element;
      return (
        <View style={styles.timeLabelsViewStyle} testID={FoundationTestKeys.usageChartTimeLabel}>
          {startDate ? (
            <VFText
              i18nKey={startDate}
              style={[styles.timeLabelsTextStyle(theme), timeLabelsTextStyle]}
              testKey={FoundationTestKeys.usageChartTimeLabelStartDate}
            />
          ) : null}
          {endDate ? (
            <VFText
              i18nKey={endDate}
              style={[styles.timeLabelsTextStyle(theme), timeLabelsTextStyle]}
              testKey={FoundationTestKeys.usageChartTimeLabelEndDate}
            />
          ) : null}
        </View>
      );
    });
  };
  renderChartInfo = () => {
    const { info, colors } = this.props;
    return _map(info, (item, index) => {
      const { label, value } = item;
      return this.renderInfo(label, value, colors[index]);
    });
  };
  renderInfo = (label, value, color) => {
    const { theme, style } = this.props;
    const { infoLabelTextStyle, infoValueTextStyle, infoIndicatorWidth = 2 } = style;
    return (
      <View style={styles.indicatorViewStyle} testID={FoundationTestKeys.usageChartInfoView}>
        <UsageIndicator
          type={ORIENTATION_TYPES.VERTICAL}
          width={infoIndicatorWidth}
          borderRadius={0}
          values={[{ value: 100 }]}
          colors={[color]}
          testID={FoundationTestKeys.usageChartInfoUsageIndicator}
        />
        {label ? (
          <VFText
            i18nKey={label}
            style={[styles.infoLabelTextStyle(theme), infoLabelTextStyle]}
            testKey={FoundationTestKeys.usageChartInfoLabel}
          />
        ) : null}
        {value ? (
          <VFText
            i18nKey={value}
            style={[styles.infoValueTextStyle(theme), infoValueTextStyle]}
            testKey={FoundationTestKeys.usageChartInfoValue}
          />
        ) : null}
      </View>
    );
  };
  render() {
    const { style, data } = this.props;
    const { chartContainerStyle } = style;
    return (
      <View testID={FoundationTestKeys.usageChartMainView}>
        <View style={styles.headerStyle} testID={FoundationTestKeys.usageChartInfoHeaderView}>
          {this.renderChartInfo()}
        </View>
        <View
          style={[styles.chartContainerStyle, chartContainerStyle]}
          testID={FoundationTestKeys.usageChartContainerView}
        >
          {!_isEmpty(data) ? (
            <>
              <View
                style={styles.columnsContainerStyle}
                testID={FoundationTestKeys.usageChartColumnsView}
              >
                {this.renderChartColumns()}
              </View>
              <View
                style={styles.timeLabelsContainerStyle}
                testID={FoundationTestKeys.usageChartTimeLabelsContainerView}
              >
                {this.renderChartTimeLabels()}
              </View>
            </>
          ) : null}
        </View>
      </View>
    );
  }
}

UsageChart.defaultProps = {
  style: {},
  theme: LightThemeColors,
  colors: [],
};

UsageChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      values: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.number,
        }),
      ),
    }),
  ),
  info: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  colors: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.shape({
    chartContainerStyle: ViewPropTypes.style,
    columnWidth: PropTypes.number,
    columnBorderRadius: PropTypes.number,
    infoIndicatorWidth: PropTypes.number,
    infoLabelTextStyle: TextPropTypes.style,
    infoValueTextStyle: TextPropTypes.style,
    timeLabelsTextStyle: TextPropTypes.style,
  }),
  theme: PropTypes.objectOf({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export { UsageChart };

export default withTheme(UsageChart);
